<template>
    <div class="page home-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="settingsData">
                    <v-card flat class="bordered px-lg-3">
                        
                        <v-card-title class="mb-1 medium-title">
                            <!-- <v-icon color="primary" size="24" class="me-1">mdi-facebook</v-icon> -->
                            <span>إعدادات حسابات التواصل الاجتماعي</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">تظهر أزرار حسابات التواصل الاجتماعي في متجرك</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>

                        <v-card-text class="pb-6">
                            <v-list class="pa-0 transparent ma-0" max-width="800">
                                <settings-item flat nullable :data="settingsData" name="facebook" icon="mdi-facebook" color="indigo darken-1" title="حساب فيسبوك" subtitle="أدخل اسم مستخدم حساب فيسبوك (الجزء اﻷخير من رابط الحساب)" @sync="sync"/>
                                <settings-item flat nullable :data="settingsData" name="messenger" icon="mdi-facebook-messenger" color="blue" title="حساب ماسنجر" subtitle="أدخل اسم مستخدم حساب فيسبوك (الجزء اﻷخير من رابط الحساب)" @sync="sync"></settings-item>
                                <settings-item flat nullable :data="settingsData" name="snapchat" icon="mdi-snapchat" color="yellow darken-1" title="حساب سناب شات" subtitle="أدخل اسم مستخدم حساب سناب شات" @sync="sync"/>
                                <settings-item flat nullable :data="settingsData" name="whatsapp" icon="mdi-whatsapp" color="green darken-1" title="رقم واتساب" subtitle="أدخل رقم واتساب الخاص بك (يتضمن رمز الدولة)" @sync="sync"/>
                                <settings-item flat nullable :data="settingsData" name="instagram" icon="mdi-instagram" color="purple" title="حساب انستجرام" subtitle="أدخل اسم مستخدم حساب انستجرام" @sync="sync"/>

                            </v-list>
                        </v-card-text>
                    </v-card>
                </div>
            </transition>
      </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import SettingsItem from '@/components/default/settings-item'


export default {
    name: "SocialSettings",
    components: {
        SettingsItem,
    },
    data(){
        return {
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        settingsData(){
            return this.$store.state.storeModule.settings;
        },

    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getStoreSettings').then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                })
            }
        },
        sync(data){
            this.$store.commit('UPDATE_STORE_SETTINGS', data);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        updatingLogo(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
